const reload =
{
    action : "Mettre à jour!" ,
    text   : "Une nouvelle version de l'application est disponible !"
};

export default reload ;